// External libraries
import gql from 'graphql-tag';

export const CART_AMOUNTS_FRAGMENT = gql`
  fragment CartAmounts on Cart {
    amounts {
      discount {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      handlingFee {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      insurance {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      shipping {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      shippingAndHandling {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      shippingDiscount {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      subtotal {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      tax {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
        currencyFormat
      }
      total {
        currencyCode
        currencyFormat
        currencyFormatSymbolISOCurrency
        currencyValue
        currencySymbol
      }
    }
  }
`;
